import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "9%"
    }, " N.Série "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "25%"
    }, " Nome/Razão Social "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "13%"
    }, " Cidade "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "13%"
    }, " Fone "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "13%"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "10%"
    }, " Môdulo "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "19%"
    }, " Ações ")
  ])
], -1)
const _hoisted_2 = { hidden: "" }
const _hoisted_3 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "bg-surface mx-auto px-6 py-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Usuários ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    "prepend-icon": "mdi-magnify",
                    modelValue: _ctx.filtro,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtro) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    density: "compact",
                    modelValue: _ctx.somenteInativo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.somenteInativo) = $event)),
                    label: "Somente Inativo?"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filtrar()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Filtar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.novo()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Novo")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_table, {
            density: "compact",
            class: "elevation-1"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usuarios, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass(item.ativo ? '' : 'text-red')
                  }, [
                    _createElementVNode("td", _hoisted_2, _toDisplayString(i), 1),
                    _createElementVNode("td", null, _toDisplayString(item.idSistema || 'Não usa'), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nome), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cidade) + " - " + _toDisplayString(item.uf), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.mascTel(item.fone)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.modulo ? item.modulo.descricao : 'Sem Môdulo'), 1),
                    _createElementVNode("td", _hoisted_3, [
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-shield-account-outline",
                        title: "É Administrador",
                        color: item.administrador ? 'orange-darken-2' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-account-tie-outline",
                        title: "É Colaborador",
                        color: item.utilizarSistema ? 'primary' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-desktop-classic",
                        title: "Utiliza Sistema",
                        color: item.baixarXLSResvista ? 'teal-darken-2' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-file-excel",
                        title: "Pode Baixar XLS Revista",
                        color: item.baixarXLSResvista ? 'primary' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-factory",
                        title: "Pode Baixar XLS Fabricante",
                        color: item.baixarXLSFabricante ? 'purple-darken-2' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-book",
                        title: "Pode baixar Revista",
                        color: item.baixarResvistaPDF ? 'primary' : 'grey-lighten-1'
                      }, null, 8, ["color"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-pencil-box-outline",
                        title: "Alterar",
                        color: "red",
                        onClick: ($event: any) => (_ctx.alterar(item.id))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-account-cog",
                        title: "Alterar",
                        color: "primary",
                        onClick: ($event: any) => (_ctx.configurarParametro(item.id))
                      }, null, 8, ["onClick"])
                    ])
                  ], 2))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}